module.exports = new __parcel__URL__("shop_machines_dimension_x.1307e1c7.png").toString();